export const APP_ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    MESSAGES: '/messages',
    PROFILE: '/profile',
    ONBOARDING: '/fb-signup-flow',
    EMPLOYEE: {
        LIST: '/employee-list',
        CREATION: '/employee-creation'
    },
    QRCODE: {
        LIST: '/qr-list',
        CREATION: '/qr-creation'
    },
    TEMPLATE: {
        LIST: '/template-list',
        CREATION: '/template-creation',
        TEMPLATE_FLOW: '/template-flow'
    },
    CAMPAIGN: {
        LIST: '/campaign-list',
        CREATION: '/campaign-creation',
        VIEW_CAMPAIGN: '/view-campaign'
    },
    CHATBOT: {
        LIST: '/chatbot-list',
        CREATION: '/chatbot-creation',
        CHATBOT_FLOW: '/botFlow'
    },
    FILES: {
        LIST: '/files-list',
        CREATION: '/files-creation'
    },
    CATEGORY: {
        LIST: '/category-list',
        CREATION: '/category-creation'
    },
    CONTACT: {
        LIST: '/contact-list',
        CREATION: '/contact-creation'
    },
    FORM: {
        LIST: '/organization-form-list',
        CREATION: '/organization-form-creation'
    },
    ORGANIZATION: {
        LIST: '/organization-list',
        CREATION: '/orgnization-creation'
    },
    BRANCH: {
        LIST: "/branch-list",
        CREATION: "/branch-creation",
    },
    DEPARTMENT: {
        LIST: "/department-list",
        CREATION: "/department-creation",
    },
    BRANCH_DEPARTMENT: {
        LIST: "/branch-department-list",
        CREATION: "/branch-department-creation",
    },
    LEADMANAGEMENT: {
        MY_TASK: '/leadmanagement/my-task',
        MY_TEAM_TASK: '/leadmanagement/my-team-task',
        LEADMANAGEMENT: '/leadmanagement/lead-management',
        USER_LEADMANAGEMENT: '/leadmanagement/user-management',
    },
    TAGS: {
        LIST: '/tag-list',
        CREATION: '/tag-creation'
    },
    QUOTATION: {
        LIST: '/quotation-list',
        CREATION: '/quotation-creation',
        QUOTATION_LIST:'/quotations',
    },
    APPOINTMENTS: {
        LIST: '/appointments',
        CREATION: '/appointments/create',
        PATIENT_HISTORY:'/appointments/patient_History'
    },
    ASSIGN_SLOTS: {
        LIST: '/assign-slots',
        CREATION: '/assign-slots/create',
    },
    SLOTS_TIMINGS: {
        LIST: '/slots',
        CREATION: '/slots/create'
    }
};
